import React from "react";
import moment from "moment";
import ImagePreview from "../../../components/ui/ImagePreview";
import PictureIcon from "../../../components/Icon/PictureIcon";

const ProntuarioContent = (props) => {
  const { mensagens, sujeitoAtencao } = props;

  const idadeSujeito = sujeitoAtencao?.dataNascimento
        ? moment().diff(sujeitoAtencao.dataNascimento, "years")
        : null;


  const renderMiniatura = (item) => {

    return (
      <ImagePreview
        urls={[item.urlMiniatura]}
        containerProps={{ 
          spacing: 8, 
          padding: 8, 
          backgroundColor: 'transparent',
          borderRadius: 8,
          maxWidth: 330,
          maxHeight: 330
        }}
        imageProps={{ 
          loading: 'lazy',
          borderRadius: 8,
        }}
        DefaultImageIcon={<PictureIcon color="#FFFFFF" size={80} />}
      />
    );
	};

  return (
    <>
      <div style={styles.textBold}>
        {sujeitoAtencao.nome || ""}
        {idadeSujeito
            ? `- ${idadeSujeito} ano${idadeSujeito > 1 ? "s" : ""}`
            : null}
      </div>
      <div style={styles.itens}>
        {mensagens.map((item, index) => {
          let mensagemInativacao = "";
          const { dataInativacao, motivo, inativador } =
            item.entradaProntuarioInativacao || "";

          if (item.tipo === "ARQUIVO" || item.tipo === "IMAGEM") {
            return null;
          }

          if (!item.ativo) {
            const nomeInativador = inativador?.nome;
            const diaInativacao = moment(dataInativacao).format("DD/MM/YYYY");
            const horaInativacao = moment(dataInativacao).format("HH:mm");
            mensagemInativacao = ` - (Registro inativado por ${nomeInativador} em ${diaInativacao} às ${horaInativacao})`;
          }

          return (
            <div key={index} style={styles.text}>
              {moment(item.dataHoraLancamento.split("[")[0]).format(
                "DD/MM/YYYY HH:mm"
              )}
              {` - ${item.profissionalSaude.nome}: `}
              <span
                style={!item.ativo ? styles.textoRiscado : styles.tamanhoFont}
              >
                {item.texto}
                {item?.tipo === "ASSINATURA_PRESENCA" && renderMiniatura(item)}
              </span>
              {!item.ativo && `${mensagemInativacao}`}
              {!item.ativo && <span>- Motivo: {motivo}</span>}
              {item?.procedimentoRealizado?.descricao && (
                <div>Observação: {item?.procedimentoRealizado?.descricao}</div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

const styles = {
  itens: {
    marginBottom: '15px',
    fontSize: '14px',
    textAlign: 'justify',
  },

  text: {
    fontSize: '14px',
    marginBottom: '15px',
  },

  textoRiscado: {
    textDecoration: 'line-through',
    fontSize: '14px',
  },

  tamanhoFont: {
    fontSize: '14px',
  },

  textBold: {
    fontWeight: 700,
    fontSize: '14px',
    marginBottom: '15px',
  },
}

export default ProntuarioContent;
